module.exports = __webpack_public_path__ + "static/media/4.3.36dbf0f1.zip";